import { FC, PropsWithChildren } from 'react';
import OpenMapLink from '../OpenMapLink';
import CopyTextAction from './CopyTextAction';

interface Props extends PropsWithChildren {
    address?: boolean;
    copy?: boolean;
    value: string | undefined | null;
    className?: string;
}
const TextAction: FC<Props> = ({
    children,
    address = false,
    copy = false,
    value,
    className = 'flex inline items-center',
}) => {
    if (!value) {
        return children;
    }
    return (
        <div className={className}>
            {children}
            {address ? <OpenMapLink address={value} /> : null}
            {copy ? <CopyTextAction value={value} /> : null}
        </div>
    );
};

export default TextAction;
